import { render, staticRenderFns } from "./CmgFooterLink.vue?vue&type=template&id=2c69c360&scoped=true&lang=pug"
import script from "./cmg-footer-link.ts?vue&type=script&lang=ts&external"
export * from "./cmg-footer-link.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgFooterLink.vue?vue&type=style&index=0&id=2c69c360&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c69c360",
  null
  
)

export default component.exports